import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';
import { appSlice } from '@bbkAdminRedux/app/app.slice';
import { appNotPersistedSlice } from '@bbkAdminRedux/rtkq/app-not-persisted.slice';
import { appPersistSlice } from '@bbkAdminRedux/rtkq/app-persist/app-persist.slice';
import { authTokenSlice } from '@bbkAdminRedux/rtkq/auth-token.slice';
import { bbkApiSlice } from '@bbkAdminRedux/rtkq/bbkApi.slice';
import {
  authPersistedSlice,
  brightbackAuthSlice,
} from '@bbkAdminRedux/rtkq/brightback-auth.slice';
import { datepickerPersistSlice } from '@bbkAdminRedux/rtkq/datepicker-persist.slice';
import { internalBbkApiSlice } from '@bbkAdminRedux/rtkq/internal.bbkApi.slice';
import { preauthBbkApiSlice } from '@bbkAdminRedux/rtkq/preauth.bbkApi.slice';
import { tabPersistSlice } from '@bbkAdminRedux/rtkq/tab-persist/tab-persist.slice';

// Nested persistor: the tab tier lives in `sessionStorage`, so it must be kept
// out of the root (localStorage) persist whitelist. It registers with the root
// persistor, which means PersistGate only opens once this record is hydrated.
//
// Deliberately unthrottled, unlike the root persistor. redux-persist drains one
// key per throttle interval and only writes once the queue is empty, so the
// shared 500ms would take a second to commit a tenant change — long enough for
// a quick reload to resume the previous one. This record is three keys, so the
// write costs nothing worth batching.
//
// Unthrottled is not synchronous: the queue still drains on a timer, so the
// write lands on the next tick rather than inside the dispatch. What goes away
// is the interval between keys.
const tabPersistedReducer = persistReducer(
  {
    key: tabPersistSlice.name,
    storage: sessionStorage,
  },
  tabPersistSlice.reducer
);

export const rootReducer = combineReducers({
  // LocalStorage reducer
  [appPersistSlice.name]: appPersistSlice.reducer,
  [datepickerPersistSlice.name]: datepickerPersistSlice.reducer,
  [authPersistedSlice.name]: authPersistedSlice.reducer,

  // SessionStorage reducer (per tab)
  [tabPersistSlice.name]: tabPersistedReducer,

  // Memory reducer
  [appSlice.name]: appSlice.reducer,
  [appNotPersistedSlice.name]: appNotPersistedSlice.reducer,
  [authTokenSlice.name]: authTokenSlice.reducer,

  // Server responses reducers
  [preauthBbkApiSlice.reducerPath]: preauthBbkApiSlice.reducer,
  [bbkApiSlice.reducerPath]: bbkApiSlice.reducer,
  [internalBbkApiSlice.reducerPath]: internalBbkApiSlice.reducer,

  // External services
  [brightbackAuthSlice.reducerPath]: brightbackAuthSlice.reducer,
});
